import React from 'react';

import CombinedText from '../../components/CombinedText';

import * as renderSensor from '../../components/sensors';

export default function NodesPlot({ config: { keys }, size }) {
  return (
    <CombinedText
      size={size}
      keys={keys}
      renderValues={keys.map(key => renderSensor[key] || renderSensor.generic(key))}
      extraRotation={0}
    />
  )
}


// WEBPACK FOOTER //
// ./src/plots/Nodes/Nodes.component.js